import MandalaDivider from "@/components/MandalaDivider";

export default function SectionHeading({ eyebrow, title, sub, align = "center", accent = "#D4AF37" }) {
  return (
    <div className={`reveal ${align === "center" ? "text-center max-w-2xl mx-auto" : ""}`}>
      {eyebrow && <div className="eyebrow" style={{ color: accent === "#D4AF37" ? "#B5901E" : accent }}>{eyebrow}</div>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#2A2118] mt-3 leading-[1.1]">
        {title}
      </h2>
      {sub && (
        <p className="mt-4 text-[15px] text-[#5C4D42] leading-relaxed">{sub}</p>
      )}
      {align === "center" && (
        <div className="mt-6"><MandalaDivider color={accent} /></div>
      )}
    </div>
  );
}
